import {
    allFetch
} from "../Domain";

/**
 * @description 簽核資料紀錄
 */
export const SignOffLog = (() => {
    /**
     * @description 建立簽核資料(formdata)
     * {
     *   sosm_id:"簽核設定主項流水號",
     *   user_id:"使用者流水號",
     *   title:"主題",
     *   "sosd_id":value/file
     *   "sosd_id":value/file
     *   "sosd_id":value/file
     *   "sosd_id":value/file
     *    ...
     * }
     */
    const SignOffLogCreate = async function (obj) {
        return await allFetch('SignOffLog/SignOffLogCreate', obj);
    }


    /**
     * @description 修改簽核資料(formdata)
     * {
     *   sosm_id:"簽核設定主項流水號",
     *   user_id:"使用者流水號",
     *   title:"主題",
     *   so_id: "簽核資料流水號"
     *   "sosd_id":value/file
     *   "sosd_id":value/file
     *   "sosd_id":value/file
     *   "sosd_id":value/file
     *    ...
     * }
     */
    const SignOffLogUpdate = async function (obj) {
        return await allFetch('SignOffLog/SignOffLogUpdate', obj);
    }

    /**
     * 送審簽核資料
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} so_id 簽核資料流水號
     * @returns 
     */
    const SignOffLogSubmit = async function (obj = { sosm_id: "", so_id: "" }) {
        return await allFetch('SignOffLog/SignOffLogSubmit', obj);
    }

    /**
     * 審核簽核資料
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} so_id 簽核資料流水號
     * @param {*} status 審核狀態
     * @param {*} note 備註
     * @returns 
     */
    const SignOffLogAudit = async function (obj = { sosm_id: "", so_id: "", status: "", note: "" }) {
        return await allFetch('SignOffLog/SignOffLogAudit', obj);
    }


    /**
     * 申請撤銷簽核資料
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} so_id 簽核資料流水號
     * @param {*} note 備註
     * @returns 
     */
    const SignOffLogCancelCreate = async function (obj = { sosm_id: "", so_id: "", note: "" }) {
        return await allFetch('SignOffLog/SignOffLogCancelCreate', obj);
    }

    /**
     * 審核撤銷簽核資料
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} so_id 簽核資料流水號
     * @param {*} status 審核狀態
     * @param {*} note 備註
     * @returns 
     */
    const SignOffLogCancelAudit = async function (obj = { sosm_id: "", so_id: "", status: "", note: "" }) {
        return await allFetch('SignOffLog/SignOffLogCancelAudit', obj);
    }

    /**
     * 查詢簽核資料
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} user_id 使用者流水號
     * @param {*} ul_id 職務流水號
     * @param {*} title 標題
     * @param {*} statuses 審核狀態們
     * @param {*} search_condition_kvs 查詢條件們
     * @param {*} my_turn 是否輪到我審
     * @param {*} sort_name 排序依據 ex. 建立時間
     * @param {*} sort_order 排序順序 <正 | 倒>
     * @param {*} page 頁碼
     * @param {*} num_per_page 一頁幾筆
     * @returns 
     */
    const SignOffLogSearch = async function (obj = {
        sosm_id: "", user_id: "", ul_id: "", title: "", statuses: "", search_condition_kvs: "", my_turn: "", sort_name: '', sort_order: '正', page: 0, num_per_page: 10
    }) {
        return await allFetch('SignOffLog/SignOffLogSearch', obj);
    }

    /**
     * 簽核資料細項
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} so_id 簽核資料流水號
     * @returns 
     */
    const SignOffLogDetail = async function (obj = { sosm_id: "", so_id: "" }) {
        return await allFetch('SignOffLog/SignOffLogDetail', obj);
    }

    return {
        SignOffLogCreate,
        SignOffLogUpdate,
        SignOffLogSubmit,
        SignOffLogAudit,
        SignOffLogCancelCreate,
        SignOffLogCancelAudit,
        SignOffLogSearch,
        SignOffLogDetail,
    }
})();